<div class="graph-container">
    <div class="header">
        <span>{{ 'HEADBAND.MODELE.MODAL.DATA.TITLE' | translate }}</span>
        <!-- légendes -->
         <div class="legendes-container">
            <div><img class="img-depth" src="assets/images/Poste_de_Pluie-cercle.svg" alt="Poste de pluie">{{ 'HEADBAND.MODELE.MODAL.DATA.RAIN' | translate }}</div>
            <div><img class="img-depth" src="assets/images/Piezometre-cercle.svg" alt="Piézomètre">{{ 'HEADBAND.MODELE.MODAL.DATA.PIEZO' | translate }}</div>
            <div><img class="img-depth" src="assets/images/Station_de_debit-cercle.svg" alt="Station de débit">{{ 'HEADBAND.MODELE.MODAL.DATA.FLOW' | translate }}</div>
         </div>
        
    </div>
    <div #mapElement class="map-modele-container"></div>
    <div id="map" class="map">
        <div id="info"></div>
    </div>
</div>
